import React from "react";
import IconButton from "@material-ui/core/IconButton";
import { Link as LinkIcon } from "@material-ui/icons";

function ShareButton({ pageType }) {
  return (
    <IconButton
      color="primary"
      aria-label={`Copy link to this ${pageType}`}
      onClick={() => {
        var dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute("value", window.location.href);
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        alert(`Copied a link to this ${pageType}!`);
      }}
    >
      <LinkIcon />
    </IconButton>
  );
}

export default ShareButton;
